import type { FaireProductEntity } from "../../entity_types/product";

export const p_yq94w3cbqw: FaireProductEntity = {
  token: "p_yq94w3cbqw",
  type: "product",
  name: "Horny for Spreadsheets",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/649a6da220bd5b06bfec345a3c979d0e5c69cc7b6b938b8a30ed92d33ce0f2ea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9b898caed57514e9e9a0270fabe7671fe82615a628e1f86cd9657e696cfc894b.jpeg",
    "https://cdn.faire.com/fastly/eedb55cd7a7c86b13a58c1e37ca557f39c4d3b91e4a8c3858981e0fcb395d280.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/e0accf29fc883c54b408021fbc44de527746ac61fd29d0975f5883afae852320.jpeg",
    "https://cdn.faire.com/fastly/2c206dc5c150c45a4af72c8d9baa78d09f48949d1c459b570eb579c9e02307b9.jpeg"
  ],
  priceDollars: 6.75,
  description: "These comfy socks scream \"conditional formatting is my love language!\" Perfect for anyone who finds spreadsheets irresistible. Cells merged. Formulas locked. Mood: *aroused*\n\nA hilarious gift for accountants, analysts, Excel pros, and anyone who gets hot for clean data. Great for office gifts, white elephant exchanges, and shops that stock nerdy or niche workwear.\n\nKey features of our Horny For Spreadsheets gym socks:\n\n• Unisex sizing\n• One size fits most \n• Comfy cushion foot\n• No toe seam\n• Made with high quality cotton in the USA\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:26.219Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
